import React from 'react';
import {UserInsights} from "types/User";
import StatList from "components/StatList";
import StatBoxSimple from "components/StatBoxSimple";
import Divider from "components/Divider";
import StackedList from "components/StackedList";
import StackedListItem from "components/StackedListItem";
import Link from "components/Link";
import {formattedDate} from "services/date";
import Card from "components/Card";
import {useQuery} from "react-query";
import SponsorType from "types/SponsorType";
import ngage from "services/ngage";

// Types ----

type SponsorshipsCardProps = {
  userId: number
  insights?: UserInsights | null
}

// Component ----

function SponsorshipsCard({userId, insights}: SponsorshipsCardProps) {

  const {data: sponsorships, isLoading: isLoadingSponsorships} = useQuery(
    ['sponsorships.all', {sponsor_type: SponsorType.USER, sponsor_id: userId}],
    () => ngage.sponsorships.filtered({sponsorType: SponsorType.USER, sponsorId: userId}),
    {keepPreviousData: true}
  )

  return (
    <Card heading="Sponsorships" isLoading={isLoadingSponsorships}>
      <StatList columns={2}>
        <StatBoxSimple name='Total' stat={insights?.sponsorship.all_sponsorships}/>
        <StatBoxSimple name='Spent' stat={insights?.sponsorship.sponsorship_spend_formatted}/>
        <StatBoxSimple name='Valid' stat={insights?.sponsorship.valid_sponsorships}/>
      </StatList>

      {!sponsorships?.data?.length ? (
        <div className="mt-6 flow-root">
          <Divider/>
          <p className="text-sm text-gray-400 mt-6">No sponsorships</p>
        </div>
      ) : (
        <div className="mt-6">
          <StackedList>
            {sponsorships?.data?.map((sponsorship) => (
              <StackedListItem hasLink={true} key={sponsorship.id}>
                <Link to={`/sponsorships/${sponsorship.id}`}>
                  <p className="truncate text-sm font-medium text-gray-500">{sponsorship.sponsorable.name}</p>

                  <div className="mt-4 grid grid-cols-1 gap-1 font-normal text-sm text-gray-900">
                    <p>
                      <span className="mr-1.5 text-gray-400">Reference:</span>
                      {sponsorship.reference}
                    </p>
                    <p>
                      <span className="mr-1.5 text-gray-400">Tier:</span>
                      {sponsorship.tier.name}
                    </p>
                    <p>
                      <span className="mr-1.5 text-gray-400">Ends:</span>
                      {formattedDate(sponsorship.ends_at)}
                    </p>
                  </div>
                </Link>
              </StackedListItem>
            ))}
          </StackedList>
        </div>
      )}
    </Card>
  );
}

// Export ----

export default SponsorshipsCard;